const version = require('../../package.json').version
const publicPath = `/webapp/${version}/`

module.exports = publicPath
